export default "/_next/static/images/app-store-b55212b9b367bfbbddc06755b5a5c67d.svg";